/**
 * @author Irakli Kandelaki
 */

/**
 * @summary Get singleview url from list data.
 */

import { useMainStore } from "@/store/main/index";
import type { ListDataInterface } from "@/types/ContentType";
import type { IndxInterface } from "@/store/main/types/StateType";

export default (data: ListDataInterface, forPage: boolean = false): string => {
  const indx = useState<IndxInterface>("data");

  const mainStore = useMainStore();
  const contentType = data?.content_type;
  const singleRouteId =
    indx.value?.contentTypes?.[contentType]?.settings?.defaultSingleRoute;

  const singleRouteMenu = indx.value?.menus?.find(
    (menu) => Number(menu?.id) === Number(singleRouteId)
  );

  if (forPage) {
    return `/${mainStore.lang}/${data?.slug}`;
  }

  return `${singleRouteMenu?.full_url}/${data?.id}-${data?.slug}/`;
};
